import { Map } from 'immutable';

import createTypedReducer from '../createTypedReducer';
import * as weatherActions from './action';
import { CHANGE_CLIENT, CLEAR } from '../authentication/action';

export const initialState = Map({
  weatherForecasts: Map(),
  weatherForecastsLoading: true
});

function resetState (state) {
  return state.withMutations((nextState) =>
    nextState
      .set('weatherForecasts', Map())
      .set('weatherForecastsLoading', true)
  );
}

export const weatherForecastReducer = createTypedReducer(initialState, {
  [weatherActions.FETCH_WEATHER] (state) {
    return state.set('weatherForecastsLoading', true);
  },

  [weatherActions.FETCH_WEATHER_SUCCESS] (state, action) {
    return state.withMutations((nextState) => {
      return nextState
        .setIn(['weatherForecasts', 'data'], action.weather)
        .set('weatherForecastsLoading', false);
    });
  },

  [weatherActions.FETCH_WEATHER_FAILED] (state) {
    return state.set('weatherForecastsLoading', false);
  },

  [CLEAR] (state) {
    return resetState(state);
  },

  [CHANGE_CLIENT] (state) {
    return resetState(state);
  }
});

export default weatherForecastReducer;
